import theme from '@theme';
import { Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';
import { ITab } from 'src/components/PageHeader/tabHeader/TabHeader';
import styled from 'styled-components';

// toutes le cartes de l'app on un padding et ici je veux une ligne qui traverse ma carte, obligé de trouver un petit tricks
// product/src/stories/Card/index.tsx
const paddingParentCard = 24;

export const HeaderSection = ({
  tabs,
  setTabSelected,
  tabSelected
}: {
  tabs: ITab[];
  setTabSelected: Dispatch<SetStateAction<ITab>>;
  tabSelected: ITab;
}) => {
  const { t } = useTranslation();
  return (
    <div>
      <StyledTitle>
        {t(
          'features.order.orderRecap.complementaryInformation.title',
          'Complementary Informations'
        )}
      </StyledTitle>

      <div
        style={{
          height: `${paddingParentCard * 2}px`,
          width: '100%',
          position: 'relative',
          display: 'flex',
          alignItems: 'center'
        }}
      >
        <div style={{ display: 'flex', gap: '20px', position: 'absolute', top: -2 }}>
          {tabs.map((tab: ITab, i: any) => (
            <TabHeaderStyle key={i}>
              <div
                onClick={() => {
                  setTabSelected(tab);
                }}
                className={`tab-name ${tabSelected.state === tab.state && 'tab-selected'}`}
              >
                {tab.i18nKey ? t(tab.i18nKey) : tab.name}
              </div>
            </TabHeaderStyle>
          ))}
        </div>
        <div
          style={{
            width: `calc(100% + ${paddingParentCard * 2}px)`,
            height: '1px',
            background: `${theme.palette.grey[200]}`,
            position: 'absolute',
            left: `-${paddingParentCard}px`
          }}
        ></div>
      </div>
    </div>
  );
};

const StyledTitle = styled.p`
  font-weight: ${theme.fonts.weight.semibold};
  font-size: ${theme.fonts.size.lg};
  color: ${theme.palette.grey[500]};
  margin-bottom: 25px;
`;
const TabHeaderStyle = styled.div`
  .tab-name {
    padding-bottom: 12px;
    font-size: ${theme.fonts.size.xs};
    font-weight: ${theme.fonts.weight.medium};
    line-height: ${theme.fonts.spacing.xs};
  }

  .tab-selected {
    padding-bottom: 10px;
    color: ${theme.palette.blue[500]};
    border-bottom: 2px solid ${theme.palette.blue[500]};
  }

  .tab-name:hover {
    padding-bottom: 10px;
    color: ${theme.palette.blue[700]};
    border-bottom: 2px solid ${theme.palette.blue[700]};
    cursor: pointer;
  }
`;
